import request from "umi-request";
import { API } from "../config";
import { APIRequest } from "./helpers/requests";

// services
import { authService } from "./ServiceAuth";

/*
 * Service functions
 */
export const planningService = {
    getEvents,
    createEvent,
    cancelEvent,
    editEvent,
    cancelDayEvents,
    markAsHighlighted,
    getPermanentEvents,
    cancelPermaEvent,
};

async function markAsHighlighted(event_id, method, actAsUser = null) {
    return await APIRequest({
        url: API.SET_HIGHLIGHTED + event_id,
        method: method,
        data: {},
        private: true,
        headers: {
            ...(actAsUser && { 'X-Acting-As': actAsUser }),
        },
    });
}

async function getEvents(params, actAsUser = null) {
    let data;
    // create Async - Await request
    let accessToken = await authService.getAccessToken();
    data = await request(API.GET_EVENTS + params, {
        method: "get",
        headers: {
            Authorization: `Bearer ${accessToken}`,
            ...(actAsUser && { 'X-Acting-As': actAsUser }),
        },
    })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return [];
        });

    return data;
}

async function getPermanentEvents(params, actAsUser = null) {
    let data;
    // create Async - Await request
    let accessToken = await authService.getAccessToken();
    data = await request(API.PERMA_EVENTS + (params ? `?${params}` : ''), {
        method: "get",
        headers: {
            Authorization: `Bearer ${accessToken}`,
            ...(actAsUser && { 'X-Acting-As': actAsUser }),
        },
    })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return [];
        });

    return data;
}

async function cancelPermaEvent(data, id, actAsUser = null) {
    let canceled;

    let accessToken = await authService.getAccessToken();
    canceled = await request(API.PERMA_EVENTS + id + "/", {
        method: "delete",
        data: data,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            ...(actAsUser && { 'X-Acting-As': actAsUser }),
        },
    })
        .then(function (response) {
            return true;
        })
        .catch(function (error) {
            return false;
        });

    return canceled;
}

async function createEvent(data, isPermanent, actAsUser = null) {
    let created;
    // create Async - Await request
    let accessToken = await authService.getAccessToken();
    created = await request(isPermanent ? API.CREATE_PERMANENT_EVENT : API.CREATE_EVENT, {
        method: "post",
        data: data,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            ...(actAsUser && { 'X-Acting-As': actAsUser }),
        },
    })
        .then(function (response) {
            return true;
        })
        .catch(function (error) {
            return false;
        });

    return created;
}

async function cancelEvent(data, id, actAsUser = null) {
    let canceled;

    let accessToken = await authService.getAccessToken();
    canceled = await request(API.EDIT_OR_CANCEL_EVENT + id, {
        method: "delete",
        data: data,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            ...(actAsUser && { 'X-Acting-As': actAsUser }),
        },
    })
        .then(function (response) {
            return true;
        })
        .catch(function (error) {
            return false;
        });

    return canceled;
}

async function editEvent(data, id, actAsUser = null) {
    let updated;

    let accessToken = await authService.getAccessToken();
    updated = await request(API.EDIT_OR_CANCEL_EVENT + id, {
        method: "put",
        data: data,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            ...(actAsUser && { 'X-Acting-As': actAsUser }),
        },
    })
        .then(function (response) {
            return true;
        })
        .catch(function (error) {
            return false;
        });

    return updated;
}

async function cancelDayEvents(data, actAsUser = null) {
    let canceled;

    let accessToken = await authService.getAccessToken();
    canceled = await request(API.CANCEL_DAY_EVENTS, {
        method: "delete",
        data: data,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            ...(actAsUser && { 'X-Acting-As': actAsUser }),
        },
    })
        .then(function (response) {
            return true;
        })
        .catch(function (error) {
            return false;
        });

    return canceled;
}
